module.exports = __webpack_public_path__ + "img/arrow-spiral.e6efa071.svg";